import { Check } from 'lucide-react';

import { cn } from 'shadcn/lib/utils';

const steps = [
    { id: 1, name: 'Enter RPC Information' },
    { id: 2, name: 'Remaining Items' },
    { id: 3, name: 'Review & Confirm' },
    { id: 4, name: 'Print Labels' },
];

/**
 * A visual stepper component for the multi-step modal.
 *
 * @param {object} props
 * @param {number} props.currentStep - The current active step, 1-indexed.
 * @returns {JSX.Element}
 */
function Stepper({ currentStep }) {
    const activeStepDetails = steps.find((step) => step.id === currentStep);
    const progressPercentage = ((currentStep - 1) / (steps.length - 1)) * 100;

    return (
        <div className="py-2">
            {/* Long Progress Bar */}
            <div className="relative h-2 w-full bg-gray-200 rounded-full mb-2">
                <div
                    className="absolute h-2 bg-blue-600 rounded-full transition-all duration-500"
                    style={{ width: `${progressPercentage}%` }}
                />
            </div>

            <div className="relative flex items-center justify-center">
                <div className="w-1/4">
                    <div className="relative flex items-center justify-between">
                        {/* Connecting line */}
                        <div className="absolute left-0 top-1/2 h-0.5 w-full -translate-y-1/2 bg-gray-200" />
                        <div
                            className="absolute left-0 top-1/2 h-0.5 w-full -translate-y-1/2 bg-blue-600 transition-all duration-500"
                            style={{ width: `${progressPercentage}%` }}
                        />

                        {steps.map((step) => (
                            <div key={step.id} className="relative z-10 flex flex-col items-center">
                                <div
                                    className={cn(
                                        'flex h-6 w-6 items-center justify-center rounded-full border-1 bg-white font-bold transition-all duration-300',
                                        currentStep === step.id
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-gray-300 text-gray-400',
                                        step.id < currentStep && 'bg-blue-600 text-white',
                                    )}
                                >
                                    <span className="text-xs">
                                        {step.id < currentStep ? (
                                            <Check className="h-5 w-5 p-1 text-white" aria-hidden="true" />
                                        ) : (
                                            step.id
                                        )}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {activeStepDetails && (
                <p className="text-center text-sm mt-1">
                    Step {activeStepDetails.id}: {activeStepDetails.name}
                </p>
            )}
        </div>
    );
}

export default Stepper;
